import { Component, Input, OnInit } from '@angular/core';
import { PropertyImageService } from '../../services/property-image.service';


// @fullcalendar plugins

@Component({
    selector: 'app-property-gallery',
    templateUrl: './property-gallery.component.html',
    styleUrls: ['./property-gallery.component.scss']
})
export class PropertyGalleryComponent implements OnInit {

    @Input() property;
    images: any[] | undefined;
    responsiveOptions: any;
    loading = true;
    showImageFullScreen = false;
    imageIndex = 0;
    currentImage: any;

    constructor(
        private readonly propertyImageService: PropertyImageService
    ) {
    }

    ngOnInit() {
        this.loading = true;
        this.setGalleryResponsive();
        this.propertyImageService.getPropertyImages(this.property.uuid).then((images) => {
            images = images.sort((a, b) => a.main_image ? -1 : 1);
            console.log(images)
            this.images = images.map((image) => {
                image.itemImageSrc = image.data;
                image.thumbnailImageSrc = image.data;
                return image;
            });
            this.loading = false;
        });
    }

    activeIndexChange(event: any): void {
        this.imageIndex = event;
    }

    async showFullScreen(event: any): Promise<void> {
        if (event.target.offsetParent.className.includes('p-galleria-item-container')) {
            this.showImageFullScreen = true;
            this.currentImage = this.images[this.imageIndex];
            const size = await this.getImageDimensions(this.currentImage.data);
            console.log(size)
        }
    }

    setGalleryResponsive(): void {
        this.responsiveOptions = [
            {
                breakpoint: '1024px',
                numVisible: 3,
                numScroll: 3
            },
            {
                breakpoint: '768px',
                numVisible: 2,
                numScroll: 2
            },
            {
                breakpoint: '560px',
                numVisible: 1,
                numScroll: 1
            }
        ];
    }

    getImageDimensions(file): Promise<any> {
        return new Promise (function (resolved, rejected) {
          var i = new Image()
          i.onload = function(){
            resolved({w: i.width, h: i.height})
          };
          i.src = file
        })
      }
}
